import { Chip, Stack, Tooltip, Typography, useTheme } from '@mui/material';
import * as React from 'react';
import { lloydConstants } from '../../Constants';
import { useViewContext } from '../../context';

/**
 * The two things a reader has to know to interpret what is on screen: how many
 * countries were withheld because filtering left too few respondents, and whether
 * the weighting is the published one. Neither survives a screenshot otherwise, and
 * both change what the ranking means.
 *
 * Sits clear of the bottom-left corner, which the colour legend owns.
 */
const ViewNotices = () => {
	const { withheld, weightingIsPublished } = useViewContext();
	const theme = useTheme();

	if (weightingIsPublished && withheld === 0) return null;

	return (
		<Stack
			spacing={'10px'}
			alignItems={'flex-start'}
			sx={{ position: 'absolute', bottom: 68, left: 20, maxWidth: 'min(460px, calc(100% - 40px))', pointerEvents: 'none' }}
		>
			{!weightingIsPublished && (
				<Tooltip
					title="You have changed the weighting of the four dimensions. The published Resilience Index weights them equally."
					placement="right"
					arrow
				>
					<Chip
						label="Custom weighting — not the published index"
						size="small"
						sx={{
							pointerEvents: 'auto',
							backgroundColor: theme.palette.primary.main,
							color: theme.palette.common.white,
							fontWeight: 500,
						}}
					/>
				</Tooltip>
			)}

			{withheld > 0 && (
				<Stack
					direction={'row'}
					spacing={'10px'}
					alignItems={'center'}
					sx={{
						pointerEvents: 'auto',
						backgroundColor: 'rgba(20, 20, 20, 0.94)',
						border: '1px solid #ffce00',
						borderRadius: '4px',
						padding: '8px 12px',
					}}
				>
					<span className="material-symbols-outlined" style={{ fontSize: 20, color: '#ffce00' }}>
						warning
					</span>
					<Typography variant={'body2'} sx={{ color: '#ffffff' }}>
						{`${withheld} ${withheld === 1 ? 'country is' : 'countries are'} hidden: ` +
							`filtering left fewer than ${lloydConstants.minSampleSize} respondents, ` +
							`which is too few to rank.`}
					</Typography>
				</Stack>
			)}
		</Stack>
	);
};

export default ViewNotices;
